import {MerchantUserResourcesAccessLink} from "./MerchantUserResourcesAccessLink";
import {Messages} from "../Messages";
import {WalletPaymentCardIcon} from "../SVGElements";
import {UI} from "../../stem-core/src/ui/UIBase";
import {styleRule} from "../../stem-core/src/decorators/Style";
import {registerStyle} from "../../stem-core/src/ui/style/Theme";
import {StyleSheet} from "../../stem-core/src/ui/Style";


class UsingBlinkDefaultPaymentMethodStyle extends StyleSheet {
    @styleRule
    element = {
        display: "flex",
        alignItems: "center",
    };

    @styleRule
    icon = {
        display: "inline-block",
        marginRight: 14,
    };

    @styleRule
    loadLink = {
        display: "inline-block",
        margin: 0,
    };
}

@registerStyle(UsingBlinkDefaultPaymentMethodStyle)
export class UsingBlinkDefaultPaymentMethod extends UI.Element {
    extraNodeAttributes(attr) {
        super.extraNodeAttributes(attr);
        attr.addClass(this.styleSheet.element);
    }

    render() {
        const {styleSheet} = this;

        return [
            <WalletPaymentCardIcon className={styleSheet.icon}/>,
            Messages.usingBlinkDefault,
            " (",
            <MerchantUserResourcesAccessLink message={Messages.load} className={styleSheet.loadLink}/>,
            ")",
        ];
    }
}
